/**
 * @file     cspEvalBlocked.ts
 * @purpose  Detect browser CSP blocks of eval / new Function so they are not
 *           reported as crashes. Production script-src omits 'unsafe-eval' on
 *           purpose; Google Ads gtag.js still probes eval on paid landings
 *           (googlesyndication referrer on /for-agents). The page keeps
 *           working — this is policy enforcement, not an app defect.
 */

const CSP_EVAL_MESSAGE =
  'Refused to evaluate a string as JavaScript';

/** True when the browser refused eval because production CSP omits unsafe-eval. */
export function isCspEvalBlocked(
  error: { name?: string; message?: string } | null | undefined,
): boolean {
  if (!error) return false;
  const msg = error.message ?? '';
  if (!msg) return false;
  if (msg.includes(CSP_EVAL_MESSAGE)) return true;
  // Firefox / older Chromium quote the directive instead of the Safari sentence.
  return (
    /content[- ]security[- ]policy/i.test(msg)
    && (msg.includes('unsafe-eval') || msg.includes('trusted-types-eval'))
  );
}
